/**
 * 온도조절기(보일러) 컨트롤러 모델 해석 유틸.
 * zone.controllers 와 device.controllerId 매칭이 어긋나거나
 * 시리얼에 하이픈 접미사가 있어도 model(T01/T02…)을 안정적으로 얻는다.
 */

const toControllerId = (controller) => {
  if (controller == null) return null;
  if (typeof controller === 'string') return controller;
  return controller._id || controller.id || null;
};

const baseSerial = (value) => {
  const id = String(value || '');
  return id.includes('-') ? id.split('-')[0] : id;
};

export function findZoneController(controllers, controllerId) {
  if (!controllerId || !controllers?.length) {
    return null;
  }
  const id = String(controllerId);
  const baseId = baseSerial(id);

  const exact = controllers.find((c) => {
    const cid = toControllerId(c);
    return cid != null && String(cid) === id;
  });
  if (exact && typeof exact === 'object') {
    return exact;
  }

  const byBase = controllers.find((c) => {
    const cid = toControllerId(c);
    if (cid == null) return false;
    const cStr = String(cid);
    const cBase = baseSerial(cStr);
    return cBase === baseId || cStr === baseId || cBase === id;
  });
  return byBase && typeof byBase === 'object' ? byBase : null;
}

/**
 * @returns {string} 모델코드 (예: T02). 없으면 빈 문자열.
 * 온도조절기 시리얼에는 모델이 없으므로, 매칭 실패 시 시리얼을 모델로 쓰지 않는다.
 */
export function resolveTempControllerModel(device, controllers) {
  const controller = findZoneController(controllers, device?.controllerId);
  if (controller?.model) {
    return String(controller.model).trim();
  }
  const id = String(device?.controllerId || '');
  // 조명제어기(M24_xxx)만 시리얼 prefix로 모델 추정
  if (id.includes('_')) {
    return id.split('_')[0];
  }
  return '';
}

/** T02 이상 등 숫자 비교 (대소문자 무시) */
export function isTempModelAtLeast(model, minNum) {
  const match = String(model || '').trim().match(/^T(\d+)$/i);
  if (!match) {
    return false;
  }
  return parseInt(match[1], 10) >= minNum;
}
